import { LimitPagination } from '@/cms/types/entry';
import { flattenEntry, getEntries } from '@/cms';

export async function searchBlogPosts(filters?: {
  topicSlug?: string;
  query?: string;
  pagination: { start: number; limit: number };
}) {
  let filterParams: Record<string, any> | undefined = undefined;

  if (filters?.query) {
    const query = filters.query.trim().toLowerCase();
    filterParams = {
      $or: [
        {
          metadata: {
            title: {
              $containsi: query,
            },
          },
        },
        {
          blog_author: {
            name: {
              $containsi: query,
            },
          },
        },
      ],
    };
  }

  if (filters?.topicSlug) {
    filterParams = {
      ...filterParams,
      metadata: {
        ...filterParams?.metadata,
        topics: {
          slug: {
            $eqi: filters.topicSlug,
          },
        },
      },
    };
  }

  const pLevelDepth = !!filterParams ? 'deep' : 'deep,5';

  const entries = await getEntries({
    apiPath: '/blogs',
    query: {
      pLevel: pLevelDepth,
      sort: ['metadata.releaseDate:desc', 'createdAt:desc'],
      filters: filterParams,
      pagination: filters?.pagination,
    },
  });

  if (!entries) return null;
  if (!entries.data.length) return null;

  const pagination = entries.meta?.pagination;

  return {
    data: entries.data.map(flattenEntry),
    pagination: (pagination || {}) as LimitPagination,
  };
}
